module.exports = "/packs/images/homepage/facilities/re_opening_safely~c3a3036f3d20ca0d0ea62bbefbc35405.jpg";